import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-37d36ea5")

_pushScopeId("data-v-37d36ea5")
const _hoisted_1 = { class: "cx-reset modal-dialog" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = { class: "modal-title" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = { class: "password-recovery" }
const _hoisted_9 = {
  key: 1,
  class: "password-recovery__invalid"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = { class: "lead" }
const _hoisted_14 = { class: "clearlist margin bottom" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_cx_spinner = _resolveComponent("cx-spinner")
  const _component_cx_reset_form = _resolveComponent("cx-reset-form")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("h4", _hoisted_4, _toDisplayString(_ctx.translations.recovery), 1)
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          (_ctx.isTokenValidationInProgress)
            ? (_openBlock(), _createBlock(_component_cx_spinner, {
                key: 0,
                loading: true,
                size: 120,
                color: "#2d84d7"
              }))
            : _createCommentVNode("", true),
          (!_ctx.isTokenValidationInProgress)
            ? (_openBlock(), _createBlock("div", {
                key: 1,
                class: "cx-reset__form",
                onKeydown: _cache[3] || (_cache[3] = $event => (_ctx.handleKeyDown($event, _ctx.setNewPassword)))
              }, [
                _createVNode("div", _hoisted_7, [
                  _createVNode("div", _hoisted_8, [
                    (_ctx.currentView === _ctx.views.resetForm)
                      ? (_openBlock(), _createBlock(_component_cx_reset_form, {
                          key: 0,
                          username: _ctx.username,
                          resetError: _ctx.resetError,
                          isResetQueryInProgress: _ctx.isResetQueryInProgress,
                          onReset: _ctx.setNewPassword
                        }, null, 8, ["username", "resetError", "isResetQueryInProgress", "onReset"]))
                      : _createCommentVNode("", true),
                    (_ctx.currentView === _ctx.views.tokenError)
                      ? (_openBlock(), _createBlock("div", _hoisted_9, [
                          (_ctx.currentErrorType)
                            ? (_openBlock(), _createBlock("p", _hoisted_10, _toDisplayString(_ctx.errorText), 1))
                            : _createCommentVNode("", true),
                          _createVNode("button", {
                            class: "btn btn-default btn-block password-recovery__invalid-btn",
                            onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.navigateToRecovery(...args)))
                          }, _toDisplayString(_ctx.translations.request), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.currentView === _ctx.views.resetSuccess)
                      ? (_openBlock(), _createBlock("div", _hoisted_11, [
                          _createVNode("p", null, _toDisplayString(_ctx.translations.success), 1),
                          _createVNode("button", {
                            class: "btn btn-default btn-block",
                            onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.navigateToLogin(...args)))
                          }, _toDisplayString(_ctx.translations.backToLogin), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_12, [
                  _createVNode("p", _hoisted_13, _toDisplayString(_ctx.translations.headline), 1),
                  _createVNode("ul", _hoisted_14, [
                    _createVNode("li", null, _toDisplayString(_ctx.translations.note), 1)
                  ])
                ])
              ], 32))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
})